import './style.scoped.css';
export interface TextContentItemProps {
  index: number;
  content: string;
}
const TextContentItem = (props: TextContentItemProps) => {
  const { index, content } = props;
  return (
    <div className="flex">
      <div className="textIndex mr-3">{index}.</div>
      <div className="textContent">{content}</div>
    </div>
  );
};

export default TextContentItem;
